import { getDealerSales } from '@api/announcement';
import ZeissSelect from '@components/select';
import { ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { Form, Input } from 'antd';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import './index.scss';
const { TextArea } = Input;

export const useDealerForm = ({
  open,
  details,
  form,
  backUpRequired_N
}: any) => {
  const [dealerList, setDealerList] = useState<any>([]);
  const [dealerSalesList, setDealerSalesList] = useState<any>([]);
  const [userInfos] = useRecoilState(userInfo);
  const dealerCorpId = details.corpId;
  const isDealer = userInfos.roleKeys === ROLE_KEYS_MAP.dealer;

  useEffect(() => {
    if (dealerList?.length > 0 && dealerCorpId) {
      const item = dealerList.find((item: any) => item.corpId === dealerCorpId);
      const newList = item?.dealerSales
        .filter((v: any) => v.userId)
        .map((v: any) => {
          const dispatchUserVaule = v?.userId + '-' + v?.realName;
          v.dispatchUserVaule = dispatchUserVaule;
          return v;
        });
      setDealerSalesList(newList ?? []);
    }
  }, [dealerList, dealerCorpId]);

  useEffect(() => {
    if (!open) {
      form.resetFields();
      return;
    }
    getListData();
  }, [open]);

  const getListData = async () => {
    const params = isDealer
      ? {
          corpId: details?.corpId
        }
      : {
          salesUserId:
            details?.subjectMatterProjectSaleId ||
            details?.currentProcessorUserId
        };
    const res: any = await getDealerSales(params);
    // const res: any = await getDealerSales({
    //   salesUserId: !details?.corpId
    //     ? details?.subjectMatterProjectSaleId || details?.currentProcessorUserId
    //     : null,
    //   corpId: details?.corpId
    // });

    setDealerList(res?.dealerCorps || []);

    if (details?.corpId) {
      form.setFieldsValue({
        corpId: details?.corpId
      });
    }
  };

  const onDealerChange = async (val: any, options: any) => {
    const { dealerSales } = options;
    const newList = dealerSales
      .filter((v: any) => v.userId)
      .map((v: any) => {
        const dispatchUserVaule = v?.userId + '-' + v?.realName;
        v.dispatchUserVaule = dispatchUserVaule;
        return v;
      });

    setDealerSalesList(newList ?? []);
  };

  const dealerForm = (
    <div className="pc-footer-sales">
      {details?.corpId && isDealer ? (
        <Form.Item
          label={'选择负责的经销商'}
          className="pc-footer-sales-select"
          name={'corpId'}
          // rules={[{ required: true }]}
        >
          {dealerList[0]?.corpName}
        </Form.Item>
      ) : (
        <Form.Item
          label={'选择负责的经销商'}
          className="pc-footer-sales-select"
          name={'corpId'}
          rules={[{ required: true }]}
        >
          <ZeissSelect
            options={dealerList}
            fieldNames={{
              label: 'corpName',
              value: 'corpId'
            }}
            onChange={onDealerChange}
          ></ZeissSelect>
        </Form.Item>
      )}

      <Form.Item
        label={'选择负责的经销商销售'}
        className="pc-footer-sales-select"
        name={'dispatchUserId'}
        rules={[{ required: true }]}
      >
        <ZeissSelect
          options={dealerSalesList}
          fieldNames={{
            label: 'realName',
            value: 'dispatchUserVaule'
          }}
        ></ZeissSelect>
      </Form.Item>
      <Form.Item
        label={'备注：'}
        name={'recordRemark'}
        rules={[{ required: !backUpRequired_N }]}
      >
        <TextArea placeholder="输入备注内容" rows={3} />
      </Form.Item>
    </div>
  );
  return {
    dealerForm
  };
};
